<template>
    <div class="column is-12 mb-2">
        <div class="card">
            <div class="card-content">
                <p class="title mb-3 is-6">
                    Offer of {{ offer.dblOfferAmount | currency(0) | withPoundSymbol }}
                </p>

                <p>
                    Fee:
                    <span
                        v-if="offer.dblSalesFee && offer.dblSalesFee > 0"
                        class="tag"
                    >
                        {{ offer.dblSalesFee | currency | withPoundSymbol }}
                    </span>
                    <span
                        v-if="offer.dblSalesFeePercentage && offer.dblSalesFeePercentage > 0"
                        class="tag"
                    >
                        {{ offer.dblSalesFeePercentage }}%
                    </span>
                </p>

                <p v-if="offer.strOfferStatus">
                    Status:
                    <span class="tag">
                        {{ offer.strOfferStatus }}
                    </span>
                </p>

                <p v-if="offer.strChainStatus">
                    Buyer's chain status:
                    <span class="tag">
                        {{ offer.strChainStatus }}
                    </span>
                </p>

                <p
                    v-if="offer.dteOffer"
                    class="subtitle mt-1 is-7"
                >
                    <small class="is-size-7 has-text-grey">
                        {{ offer.dteOffer | formatDateTime }}
                    </small>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        offer: {
            type: Object,
            required: true,
        },
    },
};
</script>
